import { Component, Input } from '@angular/core';

export type AppIcon = 'ReservationStatusWaiting' |
  'ReservationStatusPending' |
  'ReservationStatusNotConfirmed' |
  'ReservationStatusConfirmed' |
  'ReservationStatusLateBooking' |
  'ReservationStatusCheckedIn(Partial)' |
  'ReservationStatusCheckedIn' |
  'ReservationStatusWalkIn' |
  'ReservationStatusDessert' |
  'ReservationStatusPayment' |
  'ReservationStatusPrepare' |
  'ReservationStatusCheckedOut' |
  'ReservationStatusNotShown' |
  'ReservationStatusCancelled' |
  'ReservationStatusRejected' |
  'LateArrival' |
  'ArrowRight2' |
  'Calendar' |
  'Hourglass' |
  'Questionmark' |
  'ChevronDown' |
  'ChevronUp' |
  'TimeReturn' |
  'TagGroup' |
  'ReservationTagArrowRight' |
  'Smoking' |
  'Notes' |
  'Discount' |
  'Allergies' |
  'FixMenu' |
  'Cake' |
  'Dollar' |
  'Tokenization' |
  'LogoFacebook' |
  'LogoWeb' |
  'LogoInstagram' |
  'LogoDineathens' |
  'LogoGoogle' |
  'LogoGodining' |
  'User' |
  'LogoMhospitality' |
  'LogoTripadvisor' |
  'LogoResy' |
  'LogoMichelin' |
  'LogoAroundthetable' |
  'LogoTriparound' |
  'LogoThelist' |
  'LogoToptown' |
  'Rotate90' |
  'Rotate45' |
  'Rotate360' |
  'Rotate315' |
  'Edit' |
  'Delete' | 
  'ProgressBar' | 
  'Users' | 
  'TableConnections' | 
  'MenuItemWalk' |
  'MenuItemR' |
  'MenuDots' |
  'Add' |
  'Cog';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() icon: AppIcon | null = null;
  @Input() color: string | null = null;
}
